module.exports = __webpack_public_path__ + "img/r-icon-5.3312881c.png";